import { render, staticRenderFns } from "./ContabilitaSoggettoViewPage.vue?vue&type=template&id=5b0b4470&scoped=true"
import script from "./ContabilitaSoggettoViewPage.vue?vue&type=script&lang=js"
export * from "./ContabilitaSoggettoViewPage.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaSoggettoViewPage.vue?vue&type=style&index=0&id=5b0b4470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b4470",
  null
  
)

export default component.exports